import { Configuration, PopupRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || 'your-client-id',
    authority: process.env.REACT_APP_MSAL_AUTHORITY || 'https://login.microsoftonline.com/common',
    redirectUri: process.env.REACT_APP_URL || window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_URL || window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: PopupRequest = {
  scopes: [
    process.env.REACT_APP_API_SCOPE || 'api://474e206e-fd2b-44c6-b5fb-22df56605749/readwrite',
    'openid',
    'profile',
    'email',
  ],
};